import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { AppCardContainerProps } from './app-card/app-card-container';

interface SortableItemProps {
  id: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

type ChildElementPropsWithRef = AppCardContainerProps & {
  ref?: React.Ref<HTMLDivElement>;
};

const SortableItem: React.FC<SortableItemProps> = ({
  id,
  children,
  style: incomingStyle,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isSorting,
  } = useSortable({ id });

  const baseTransformStyle = CSS.Transform.toString(transform);

  let finalTransformStyle = baseTransformStyle;

  // disable scaling
  if (isDragging && transform) {
    finalTransformStyle = `translate3d(${transform.x}px, ${transform.y}px, 0)`;
  } else if (isSorting && transform) {
    finalTransformStyle = `translate3d(${transform.x}px, ${transform.y}px, 0)`;
  }

  const dndKitStyle: React.CSSProperties = {
    transform: finalTransformStyle,

    transition,
    zIndex: isDragging ? 10 : 'auto',
  };

  const mergedStyle = {
    ...incomingStyle,
    ...dndKitStyle,
  };

  if (React.isValidElement<ChildElementPropsWithRef>(children)) {
    const finalStyle = children.props.style
      ? { ...children.props.style, ...mergedStyle }
      : mergedStyle;

    return React.cloneElement(children, {
      ref: setNodeRef,
      style: finalStyle,
      ...attributes,
      listeners: listeners as any,
    });
  }

  return (
    <div ref={setNodeRef} style={mergedStyle} {...attributes} {...listeners}>
      {children}
    </div>
  );
};

export default SortableItem;
